<template>
  <div class="app-container crm-detail">
    <el-card class="box-card mariginBottom" shadow="hover">
      <div slot="header" class="clearfix">
        <span>公司信息</span>
      </div>
      <el-row class="mariginBottom">
        <el-col :span="6">
          <div class="grid-content">租户名称：{{detail.tenantFullName}}</div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content">租户类型：{{detail.tenantTypeDesc}}</div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content">
            联系人姓名：{{detail.linkNickName}}
            <!-- <el-tooltip class="item" effect="dark" :content="detail.linkNickName" placement="top-start">
              <el-button type="text" style="padding:0">展示</el-button>
            </el-tooltip> -->
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content">联系人手机号：{{detail.linkTel}}</div>
        </el-col>

      </el-row>
      <el-row>
         <el-col :span="6">
          <div class="grid-content">
            城市：{{detail.city}}
            <!-- <el-tooltip class="item" effect="dark" :content="detail.city" placement="top-start">
              <el-button type="text" style="padding:0">展示</el-button>
            </el-tooltip> -->
          </div>
        </el-col>
        <el-col :span="18">
          <div class="grid-content">详细地址：{{detail.detailAddress}}</div>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="box-card mariginBottom" shadow="hover">
      <div slot="header" class="clearfix">
        <span>订购套餐</span>
      </div>
      <p>
        <el-button type="primary" @click="handleAddPackage">添加套餐</el-button>
      </p>
      <el-table v-loading="loading" :data="packageList">
        <el-table-column label="套餐名称" min-width="150" align="center" prop="packageName">
          <template slot-scope="scope">
          <el-button @click="goPackageDetail(scope.row)" type="text">{{scope.row.packageName}}</el-button>
        </template>
        </el-table-column>
        <el-table-column label="单价（元）" min-width="100" align="center" prop="packageSinglePrice">
          <template slot-scope="scope">
           {{scope.row.packageSinglePrice ? amountFormat(scope.row.packageSinglePrice) : 0}}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="订购数量" min-width="100" align="center" prop="buyCount">
          <!-- <template slot-scope="scope">
            <el-button type="text" @click="handleDelete(scope.row)">删除</el-button>
          </template> -->
        </el-table-column>
        <el-table-column label="合计（元）" min-width="100" align="center" prop="packageTotalPrice">
          <template slot-scope="scope">
           {{scope.row.packageTotalPrice ? amountFormat(scope.row.packageTotalPrice) : '0'}}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="收款合计（元）" min-width="140" align="center" prop="chargeTotalAmount">
          <template slot-scope="scope">
            <el-button type="text" @click="feeRecordList(scope.row)">{{scope.row.chargeTotalAmount ? amountFormat(scope.row.chargeTotalAmount) : 0}}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="生效时间" min-width="180" align="center" prop="validityStartTime" />
        <el-table-column label="到期时间" min-width="180" align="center" prop="validityEndTime" />
        <el-table-column label="状态" min-width="100" align="center" prop="packageStatusStr" />
        <el-table-column label="备注" min-width="180" align="center" prop="buyRemark" />
        <el-table-column label="操作" min-width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="changePackageStatus(scope.row)" v-if="scope.row.packageStatus === 4">启用</el-button>
            <el-button type="text" @click="changePackageStatus(scope.row)" v-if="scope.row.packageStatus === 2 || scope.row.packageStatus === 1">停用</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="packageTotal>0"
        :total="packageTotal"
        :page.sync="queryPackageParams.pageNum"
        :limit.sync="queryPackageParams.pageSize"
        @pagination="buyPackageList"
      />
    </el-card>
    <el-card class="box-card mariginBottom" shadow="hover">
      <div slot="header" class="clearfix">
        <span>子账号</span>
      </div>
      <el-button type="primary" style="margin-bottom: 10px" v-if="!detail.hasAdminUser" @click="handleAddAdminUser">添加超管</el-button>
      <el-table v-loading="loading" :data="userList">
        <el-table-column label="员工姓名" min-width="150" align="center" prop="nickName" />
        <el-table-column label="手机号" min-width="100" align="center" prop="phoneNumber" />
        <el-table-column label="添加日期" min-width="110" align="center" prop="createTime"></el-table-column>
      </el-table>
      <pagination
        v-show="userTotal>0"
        :total="userTotal"
        :page.sync="userParqms.pageNum"
        :limit.sync="userParqms.pageSize"
        @pagination="tenantUserList"
      />
    </el-card>
    <el-dialog title="收款记录" :visible.sync="dialogTableVisible">
      <p>合计收款：{{amountFormat(totalAmount)}}元 <el-button type="primary" size="mini" @click="handleAdd">添加</el-button></p>
      <el-table :data="list" ref="multipleTable" >
        <el-table-column label="日期"  prop="feeTime" width="200"></el-table-column>
        <el-table-column label="收款方式"  prop="chargeType"></el-table-column>
        <el-table-column label="金额（元）"  prop="feeAmount" width="120">
          <template slot-scope="scope">
            {{scope.row.feeAmount ? amountFormat(scope.row.feeAmount) : 0}}
          </template>
        </el-table-column>
        <el-table-column label="备注"  prop="remark" width="140"></el-table-column>
        <el-table-column label="操作"  prop="remark" width="60">
          <template slot-scope="scope">
            <el-button type="text" @click="deleteFeeRecord(scope.row, scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="recordTotal>0"
        :total="recordTotal"
        :page.sync="queryRecordParams.pageNum"
        :page-sizes="[5, 10, 20]"
        :limit.sync="queryRecordParams.pageSize"
        @pagination="feeRecordList(recordRow)"
      />
    </el-dialog>
    <AddCollectionRecordDialog ref="addTenantDialogRef" @success="addFeeRecord"></AddCollectionRecordDialog>
    <el-dialog title="添加超管" :visible.sync="addAdminUserDialogFlag" :close-on-click-modal="false" width="500px">
      <el-form :model="addAdminUserForm" :rules="addAdminUserRules" ref="addAdminUserForm" label-width="100px">
        <el-form-item label="姓名:" prop="userNickName">
          <el-input type="text" :maxlength="30" v-model="addAdminUserForm.userNickName" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="手机号:" prop="phoneNum">
          <el-input type="text" :maxlength="11" v-model="addAdminUserForm.phoneNum" placeholder="请输入" clearable />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addAdminUserDialogFlag = false">取消</el-button>
        <el-button type="primary" @click="confirmAddAdminUser">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  addAdminUser,
  addFeeRecord,
  buyPackageList,
  changePackageStatus,
  deleteFeeRecord,
  feeRecordList,
  queryTenantDetail,
  tenantUserList
} from "@/api/saas/package";
import AddCollectionRecordDialog from "../components/addCollectionRecordDialog.vue";
import {amountFormat} from "@/utils/index";

export default {
  name: "InvoiceDetail",
  components: {
    AddCollectionRecordDialog
  },
  data() {
    return {
      recordRow: {},
      amountFormat,
      loading: false,
      dialogTableVisible: false,
      addAdminUserDialogFlag: false,
      tenantId: null,
      detail: {},
      queryPackageParams: {
        pageNum: 1,
        pageSize: 10,
      },
      addAdminUserForm: {
        tenantId: this.$route.query.id,
        userNickName: '',
        phoneNum: ''
      },
      packageTotal: 0,
      packageList: [],
      dataList: [],
      queryRecordParams: {
        pageNum: 1,
        pageSize: 5,
      },
      list: [], // 收款记录
      recordTotal: 0,
      totalAmount: 0,
      total: 0,
      userParqms: {
        pageNum: 1,
        pageSize: 10,
      },
      userList: [],
      userTotal: 0,
      addAdminUserRules: {
        userNickName: [
          { required: true, message: "请输入姓名", trigger: "change" }
        ],
        phoneNum: [
          { required: true, message: "请输入手机号", trigger: "change" }
        ]
      },
    };
  },
  watch: {
    dialogTableVisible(val){
      if(!val) {
        this.queryRecordParams.pageNum = 1
      }
    }
  },
  created() {
    this.tenantId = this.$route.query.id;
    this.queryDetail();
    this.buyPackageList()
    this.tenantUserList()
  },
  methods: {
    addFeeRecord(row) {
      console.log('row', row)
      addFeeRecord({
        buyId: this.recordRow.buyId,
        chargeType: row.chargeType,
        feeAmount: row.feeAmount,
        feeTime: row.feeTime,
        remark: row.remark,
        tenantId: this.detail.tenantId
      }).then(response => {
          this.feeRecordList(this.recordRow)
          that.buyPackageList()
        }).catch(error => {
          loading.close()
        })
    },
    deleteFeeRecord(row) {
      const that = this
      this.$confirm(`确认删除该条记录吗？`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteFeeRecord({
          feeRecordId: row.feeRecordId
        }).then(response => {
            that.msgSuccess('删除成功！')
            that.feeRecordList(this.recordRow)
            that.buyPackageList()
          }).catch(error => {
          })
        })
    },
    // 添加收款记录
    handleAdd() {
      this.$refs.addTenantDialogRef.open();
    },
    feeRecordList(row) {
      console.log('row', row)
      this.recordRow = row
      this.dialogTableVisible = true
      feeRecordList(Object.assign(this.queryRecordParams,{buyId: this.recordRow.buyId})).then(response => {
            this.list = response.rows
            this.recordTotal = response.total
            this.totalAmount = response.otherData
          }).catch(error => {
          })
    },
    handleAddPackage() {
      this.$router.push({
        path: "/saas/tenant/packageDetail",
        query: {
          tenantId: this.tenantId
        }
      });
    },
    buyPackageList(){
      buyPackageList(Object.assign(this.queryPackageParams,{tenantId: this.tenantId}))
        .then(response => {
          this.packageList = response.rows || {};
          this.packageTotal = response.total
        })
        .catch(error => {
          this.loading = false;
        });
    },
    tenantUserList() {
      tenantUserList(Object.assign(this.userParqms,{tenantId: this.tenantId}))
        .then(response => {
          this.userList = response.rows || {};
          this.userTotal = response.total
        })
        .catch(error => {
          this.loading = false;
        });
    },
    queryDetail() {
      queryTenantDetail({
        tenantId: this.tenantId
      })
        .then(response => {
          this.detail = response.data || {};
        })
        .catch(error => {
          this.loading = false;
        });
    },
    changePackageStatus(row) {
      this.$confirm(`确认${row.packageStatus === 4 ? '启用': '停用'}该套餐吗？`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.change(row)
      })

    },
    change(row) {
      changePackageStatus({
        buyId: row.buyId,
        optType: row.packageStatus === 4 ? 2: 1
      })
        .then(response => {
          this.msgSuccess('更改成功！')
          this.buyPackageList()
        })
        .catch(error => {
          this.loading = false;
        });
    },
    // 跳转套餐详情
    goPackageDetail(row) {
      this.$router.push({
        path: `/saas/package/detail?packageId=${row.packageId}`
      })
    },
    handleAddAdminUser () {
      this.resetForm("addAdminUserForm");
      this.addAdminUserDialogFlag = true
    },
    confirmAddAdminUser() {
      const loading = this.$loading({lock: true, text: '操作中', spinner: 'el-icon-loading'});
      addAdminUser(this.addAdminUserForm).then(response => {
        this.msgSuccess('添加成功')
        this.tenantUserList()
        this.addAdminUserDialogFlag = false
      }).finally(()=>{
        loading.close()
      })
    }
  }
};
</script>

<style lang='scss' scoped>
.mariginBottom {
  margin-bottom: 20px;
}
</style>

